module.exports = __webpack_public_path__ + "img/books.b3caf9db.jpg";